import { Box, SxProps } from "@mui/material";
import { useGetOnboardQuery } from "src/context/api/onboard/api";
import { usePathname } from "src/routes/hooks";
import BannersGrid from "src/sections/overview/dashboards/views/admin/onboard/grid";

export default function Section({ children, ...other }: { children: React.ReactNode } & { sx?: SxProps }) {
    const pathname = usePathname();
    const { data: allBanners, refetch } = useGetOnboardQuery();
    const banners = allBanners?.filter((banner) => banner.target === pathname);

    const routes = [
        "/brand-overview",
        "/optimization/campaigns",
        "/optimization/activations/active-mode",
        "/optimization/scraping",
        "/optimization/activations/ko-bidding/max-cpc",
        "/optimization/activations/ko-bidding/troas",
        "/optimization/activations/ko-bidding/tcpa",
        "/optimization/activations/ko-bidding/target-impression-share",
        "/optimization/activations/ko-bidding-auto",
        "/brand-wayback",
        "/admin/users",
        "/admin/users/add",
        "/workspaces",
        "/workspaces/add",
        "/optimization/activations/overview",
        "/admin/features/live-bidding/ad-group-based",
        "/",
        "/non-branded/search-terms",
        "/non-branded/competitors",
        "/non-branded/conquest-mode",
        "/account",
        "/admin/sso/list"
    ];

    const isSpecialRoute = routes.includes(pathname) || window.location.pathname.startsWith("/workspaces/") || window.location.pathname.startsWith("/competitor/");
    const isCompetitiveRouteButNotAds = pathname?.startsWith("/visibility") && !pathname?.startsWith("/visibility/ads");
    const isOptimizationRoute = pathname?.startsWith("/optimization");
    const isBrandPulseRoute = pathname?.startsWith("/brand-pulse");
    const isCompetitiveAdsRoute = pathname?.startsWith("/visibility/ads");
    const isConquestModeRoute = pathname?.startsWith("/non-branded/conquest-mode");

    let paddingTop = 22;
    if (isCompetitiveRouteButNotAds) paddingTop = 14;
    else if (isOptimizationRoute) paddingTop = 14;
    else if (isCompetitiveAdsRoute) paddingTop = 18;
    else if (isSpecialRoute) paddingTop = 16;
    else if (isBrandPulseRoute) paddingTop = 4;
    else if (isConquestModeRoute) paddingTop = 4;
    return (
        <Box className="section-banner-app-wrapper" sx={{ pt: paddingTop, pb: 2, ...other.sx }}>
            <Box px={"24px"}>
                <BannersGrid
                    banners={banners || []}
                    edit={false}
                    dismiss={true}
                    onDismiss={refetch}
                />
            </Box>

            {children}
        </Box>
    );
}


